<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Festivals (Multi-Category)
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <div class="sixcol">
          <p>In 2025, <strong>Festivals (Multi-Category)</strong> recorded $92.6m in revenue and over 2.4m attendances. This is the highest revenue recorded for this category, while attendance was the second-highest recorded (with 2018 being the highest).</p>
          <p><strong>Festivals (Multi-Category)</strong> recorded a y-o-y increase in revenue of 10.1% (from $84.1m in 2024 to $92.6m in 2025). This was primarily driven by a y-o-y increase in attendance of 10.1% (from 2.2m in 2024 to 2.5m in 2025), partially offset by a y-o-y decline in the average ticket price of 2.9% (from $43.39 in 2024 to $42.15 in 2025).</p>
          <p>The inclusion of new data providers partially explains the growth in revenue and attendance for this category.</p>
          <p>In 2025 the major contributing events in this category were Adelaide Fringe, Adelaide Festival, Brisbane Festival, Darwin Festival, Fringe World Festival (Perth), Woodford Folk Festival, Dark Mofo, RISING, Sydney Festival, Oktoberfest in the Gardens and Perth Festival.</p>
          <p><strong>Festivals (Multi-Category)</strong> contributed 2.8% of the total share in revenue and 8.0% of the total share in attendance in 2025.</p>
        </div>
        <div class="sixcol last">
          <p>In 2025, SA and WA generated the largest shares of revenue and attendance in this category. Together, these two states generated 51.6% of overall revenue and 62.0% of overall attendance in this category in 2025.</p>
          <p>Major festivals in SA and WA included Adelaide Fringe, Adelaide Festival, Fringe World Festival (Perth), Oktoberfest in the Gardens and Perth Festival.</p>
          <p>TAS recorded the highest y-o-y increase in revenue and attendance in 2025, primarily due to the return of Dark Mofo. ACT recorded the second-highest y-o-y increase in revenue and attendance in 2025, primarily driven by Floriade NightFest.</p>
          <p>In 2025, all states and territories except NSW and VIC recorded y-o-y growth in revenue, while all states and territories except QLD, WA and NT recorded y-o-y growth in attendance.</p>
        </div>
      </div>
    </article>

    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure id="classical-music-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>

        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.<br>Categories/States with zero or &lt;0.05% of revenue and/or attendance<br> may not be reflected in the pie chart.</div>
        </div>
      </div>
    </figure>

    <div class="row clearfix">
      <h2 id="download-btn">Download the Report</h2>
      <div class="execsumm" style="justify-content: center;">
        <a href="./pdf/2025/FESTIVALS (MULTI CATEGORY)  Live Performance Industry in 2025.pdf" class="button fullreport pdf" target="_blank">
          Festivals (Multi-Category) Infographic Report 2025 (PDF)
        </a>
      </div>
    </div>

    <div class="fullbg">
      <p class="caption">Photo: <em>Fringe Flavours Night Market - Tash York</em>, Melbourne Fringe, Photo Credit: Tom Noble Creative</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter: function() {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(3) + 'b'
            } else {
              revy = '$' + rev.y.toFixed(3) + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'center',
          verticalAlign: 'bottom',
          floating: false,
          backgroundColor: '#FFFFFF'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [14.842, 5.171, 9.633, 9.318, 21.616, 10.643, 9.571, 11.777, 12.917, 25.622, 47.805, 62.162, 56.642, 54.636, 68.973, 54.985, 39.493, 37.673, 70.102, 92.422, 84.094, 92.620],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [0.484, 0.157, 0.202, 0.294, 0.552, 0.431, 0.263, 0.242, 0.261, 0.787, 1.06, 1.487, 1.549, 1.866, 2.578, 2.174, 1.568, 1.554, 2.125, 2.411, 2.231, 2.456],
          color: '#d14967'
        }]
      },
      activeYear: 2025,
      stateBreakdowns: [
        {
          year: 2025,
          revenue: [
            ["NSW", 14.1],
            ["VIC", 9.5],
            ["QLD", 14.8],
            ["WA", 17.2],
            ["SA", 34.4],
            ["ACT", 1.1],
            ["TAS", 5.1],
            ["NT", 3.9],
          ],
          attendance: [
            ["NSW", 11.8],
            ["VIC", 8.2],
            ["QLD", 7.4],
            ["WA", 14.9],
            ["SA", 47.1],
            ["ACT", 1.0],
            ["TAS", 7.1],
            ["NT", 2.5],
          ]
        }
      ],
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown () {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [
              {
                name: 'Attendance Share',
                data: stateBreakdown.attendance,
                size: '68%',
                innerSize: '40%',
                borderColor: 'none',
                borderWidth: 1,
                slicedOffset: 30,
                showInLegend: true,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -28
                }
              }, 
              {
                name: 'Revenue Share',
                data: stateBreakdown.revenue,
                size: '100%',
                innerSize: '70%',
                borderColor: 'transparent',
                borderWidth: 1,
                dataLabels: {
                  color: '#000',
                  style: {
                    textShadow: 'none',
                  },
                  formatter: function() {
                    if (this.y > 3) {
                      return this.y.toFixed(1) + '% '
                    }
                  },
                  distance: -32
                }
              }
            ],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url("~@/assets/img/2025/25-Festivals-(Multi)-Tash-York-at-Fringe-Flavours-Night-Market,-photograph-by-Tom-Noble-Creative.jpg");
  background-position: top center;
}
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
